"use client";

import Link from "next/link";

/**
 * Site-wide announcement strip above the header ("eShop coming soon", owner,
 * Nov 2026). Not sticky: it scrolls away with the page and leaves the header
 * where it always was.
 *
 * A visitor who closes it does not see it again. The choice lives in this
 * browser only (localStorage), and an inline script hides the bar before the
 * first paint, so a returning visitor's page does not jump. Change the key
 * when the message changes, so everyone sees the new one.
 */
const STORAGE_KEY = "pbd-announce-eshop-2026-11";
const BAR_ID = "pbd-announcement";

export function AnnouncementBar() {
  function close() {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // Storage blocked (private window): the bar just closes for this page.
    }
    const bar = document.getElementById(BAR_ID);
    if (bar) bar.hidden = true;
  }

  return (
    <div
      id={BAR_ID}
      role="region"
      aria-label="Announcement"
      // The inline script below may set `hidden` before React hydrates.
      suppressHydrationWarning
      className="relative border-b border-[color-mix(in_srgb,var(--cta)_30%,transparent)] bg-[color-mix(in_srgb,var(--cta)_14%,var(--background))] text-[var(--foreground)]"
    >
      <script
        // Runs while the HTML is parsed, before paint: no flash, no shift.
        dangerouslySetInnerHTML={{
          __html: `try{if(localStorage.getItem(${JSON.stringify(STORAGE_KEY)}))document.getElementById(${JSON.stringify(BAR_ID)}).hidden=true}catch(e){}`,
        }}
      />
      <Link
        href="/shop"
        className="flex items-center justify-center gap-2.5 px-11 py-2 text-[13px] leading-snug text-[var(--foreground)] no-underline"
      >
        <span className="pbd-pulse-dot shrink-0" aria-hidden />
        <span className="pbd-shine font-bold tracking-[0.04em]">eShop</span>
        <span className="text-[var(--muted)]" aria-hidden>
          ·
        </span>
        <span className="font-semibold tracking-[0.14em] text-[11px] uppercase">Coming soon</span>
      </Link>
      <button
        type="button"
        onClick={close}
        aria-label="Close announcement"
        className="absolute top-1/2 right-2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-full text-lg leading-none text-[var(--muted)] hover:bg-[color-mix(in_srgb,var(--foreground)_8%,transparent)] hover:text-[var(--foreground)]"
      >
        ×
      </button>
    </div>
  );
}
